<template>
    <transition name="fade">
        <div class="modal-back" v-if="show">
            <transition>
                <div class="modal-popup">
                    <slot></slot>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        show (newVal) {
            const body = document.querySelector('body')
            if (newVal) body.classList.add('modal-open')
            else body.classList.remove('modal-open')
        }
    }
}
</script>

<style scoped>
    .modal-back {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: #04040f66;
        z-index: 1031;
    }

    .modal-popup {
        position: fixed;
        bottom: 0;
        width: 100%;
        background-color: #fff;
        padding: 25px 30px 30px 30px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s;
        z-index: 1031;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        z-index: 1031;
    }
</style>
